import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'


export default function Projectlist() {
    const [listProjectArray, setListProjectArray] = useState([]);
    const [removeProajectId, setRemoveProajectId] = useState('');
    const [completeProajectId, setCompleteProajectId] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        var adminmember = localStorage.getItem('user_position');
        if (adminmember === 'Member') {
            $('.add_new_pro').css('display', 'none')
        }

        var company_id = localStorage.getItem('mem_company_id');
        var comname = localStorage.getItem('mem_company_name');
        var obj = {
            companyId: company_id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });


    }, [])


    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    function goForProjectDetails(id, pro_name, pr_last_date) {
        localStorage.setItem('selected_project_id', id);
        localStorage.setItem('selected_project_name', pro_name);
        localStorage.setItem('initialpage', 'members');
        localStorage.setItem('deadline', pr_last_date);
        navigate('/project_details');
    }

    function removePro(id) {
        setRemoveProajectId(id)
        $('#projectRemove').css('display', 'block')
    }

    function clsoeMemProjectremove() {
        $('#projectRemove').css('display', 'none')
    }
    function removeProject() {
        var pid = removeProajectId
        var obj = {
            primary_key: pid
        }
        $.ajax({
            type: 'POST',
            url: 'removeProject.php',
            data: obj,
            cache: false,
            success: function (result) {
                if (result != 'fail') {
                    showAlert('Removed successfully');
                    setTimeout(resetlist, 1500)
                } else {
                    showAlert('Cannot remove project.');
                }
            },
        });
    }


    function openCompletePop(id) {
        setCompleteProajectId(id)
        $('#projectcomplete').css('display', 'block');
    }

    function clsoeMemProjectComplete() {
        setCompleteProajectId('')
        $('#projectcomplete').css('display', 'none');
    }

    function completeProject() {
        var obj = {
            primary_key: completeProajectId
        }
        $.ajax({
            type: 'POST',
            url: 'CompleteProject.php',
            data: obj,
            cache: false,
            success: function (result) {
                if (result != 'fail') {
                    showAlert('Project status updated successfully');
                    setTimeout(resetlist, 1500)
                } else {
                    showAlert('Cannot updated project status.');
                }
            },
        });
    }

    function resetlist() {
        navigate('/re_procectlist');
    }

    function viewTotalDetails(details) {
        console.log(details)
        $('#detailpop').css('display', 'block');
        $('#alert_text').text(details);

    }

    function closeDetails() {
        $('#detailpop').css('display', 'none');
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Projects</h2>
                    <Link className='pull_right add_new_pro' to="/create_projects">Add New Project</Link>
                    <Link className='pull_right add_new_pro' to="/complete_projects">View Completed Projects</Link>

                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>

                    <div className='vl_listing_area'>

                        {listProjectArray.map((item, index) => {
                            const activestatus = item.pr_complete_status === 'Active';
                            if (!activestatus) return null; // skip inactive items

                            return (
                                <div className='resource_card_one_third' key={index}>
                                    <div className='resource_inner'>
                                        <div className='fullwidth pull_left pt-21'>
                                            <h3>{item.pro_name}</h3>
                                            <div className='fullwidth pull_left pb-10'>
                                                <span>Date : {item.pr_start_date}</span>
                                                <span>Time Worked : {item.pr_overall_prog}</span>
                                            </div>
                                        </div>

                                        <div className='divider'>&nbsp;</div>
                                        <div className='vl_dsh_one_half'>
                                            <p>Member Working: {item.pr_team}</p>
                                        </div>
                                        <div className='vl_dsh_one_half'>
                                            <p>Deadline: {item.pr_last_date}</p>
                                        </div>
                                        <div className='list_buttonholder'>
                                            <button onClick={() => goForProjectDetails(item.primary_key, item.pro_name, item.pr_last_date)}>View</button>
                                            <button className='rightgap backtranparent' onClick={() => removePro(item.primary_key)}><i className='ri-delete-bin-3-fill'></i>
                                            </button>
                                            <button className='rightgap backtranparent' onClick={() => openCompletePop(item.primary_key)}>
                                                <i className='ri-checkbox-circle-line' title="Mark as complete"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>


            <div className='vl_dsh_popup' id="detailpop">
                <div className='detailsbox'>
                    <div className='alertheader'><h3><i class="ri-file-list-3-line"></i>Details</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeDetails}>Close</button>
                    </div>
                </div>
            </div>
            <div className='vl_dsh_popup' id="projectcomplete">
                <div className='memlistareashort'>

                    <div className='memlistcontainer'>
                        <p>Are you sure this project has been completed?</p>
                        <div className='vl_dsh_buttonholder'>
                            <button onClick={completeProject}>Yes</button>
                            <button className='closebtn' onClick={clsoeMemProjectComplete}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="projectRemove">
                <div className='memlistareashort'>

                    <div className='memlistcontainer'>
                        <p>Are you sure you want to remove this project?</p>
                        <div className='vl_dsh_buttonholder'>
                            <button onClick={removeProject}>Yes</button>
                            <button className='closebtn' onClick={clsoeMemProjectremove}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
